/*
get hubspot form from dom. Add event listener to it. Add popup class to body after 5000ms. Add close button to popup. Add event listener to close button. Remove popup class from body on click.
*/

const hubspotForm = () => {
  const form = document.querySelector('.hbspt-form');
  const body = document.querySelector('body');
  const closeBtn = document.createElement('button');

  if (form) {

    setTimeout(() => {
      body.classList.add('popup');
      closeBtn.classList.add('popup__close');
      closeBtn.innerHTML = 'X';
      form.appendChild(closeBtn);

    }, 5000);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      body.classList.remove('popup');
      form.remove();
    });
  }

}

export default hubspotForm;
